module.exports = __webpack_public_path__ + "media/images/bg-1-606d9de807179bcca0e0e37c173ff44f.jpg";